var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.108,
    height: 12.107,
    viewBox: "0 0 12.108 12.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Price_Tag_-_Black_Small",
    "data-name": "Price Tag - Black Small",
    transform: "translate(3.699 0.19) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag_Rectangle_-_small",
    "data-name": "Tag Rectangle - small",
    transform: "translate(1.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19753",
    "data-name": "Rectangle 19753",
    d: "M0,0H6.481A2.481,2.481,0,0,1,8.962,2.481v0A2.481,2.481,0,0,1,6.481,4.963H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 0)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163312",
    "data-name": "Path 163312",
    d: "M147,325.962s8.394,0,8.422,0c.484,0,.484-.591.484-.591v-3.78a.523.523,0,0,0-.484-.591H147",
    transform: "translate(-147 -321)",
    stroke: "#b1b3b3",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Price_Tag_Tip_-_small",
    "data-name": "Price Tag Tip - small",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163313",
    "data-name": "Path 163313",
    d: "M136.225,324l1.736,1.964V321l-1.736,1.964A.817.817,0,0,0,136.225,324Zm1.005-1.038a.532.532,0,1,1-.424.521A.48.48,0,0,1,137.23,322.961Z",
    transform: "translate(-136.032 -321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163314",
    "data-name": "Path 163314",
    d: "M137.929,321l-1.736,1.964a.8.8,0,0,0,0,1.035c.433.567,1.736,1.964,1.736,1.964",
    transform: "translate(-136 -321.002)",
    stroke: "#b1b3b3",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_401",
    "data-name": "Ellipse 401",
    cx: 0.434,
    cy: 0.508,
    rx: 0.434,
    ry: 0.508,
    transform: "translate(0.764 1.974)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTagIcon);
export default __webpack_public_path__ + "static/media/price-tag-icon.de6eed0b252001d079553fb932c795ac.svg";
export { ForwardRef as ReactComponent };